import React, { useCallback } from 'react';

// Enumerables
import { AxiosResponse } from 'axios';
import { useNavigate } from 'react-router';
import { Namespace } from '../../../translation/namespace';

// Components
import Form from '../../molecules/Form/Form';
import { FormContainerModifier } from '../../molecules/Form';
import { UserRegistrationFormTemplate } from './partials/UserRegistrationFormTemplate';
import { UserRegistrationForm as UserRegistrationFormApi } from '../../../types/api/UserRegistration';
import { SonApiResponse } from '../../../types/api/SonApiResponse';
import { StatusInfoError } from '../../../_lib/components/StatusInfo';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export type UserRegistrationFormProps = UserRegistrationFormApi & {
  pageTitle: string;
  roleName: string;
};

export function UserRegistrationForm(props: UserRegistrationFormProps) {
  const { t } = useSonTranslation(Namespace.UserRegistrationForm);
  const navigate = useNavigate();

  const onSuccess = useCallback(
    (response: AxiosResponse<SonApiResponse>) => {
      if (response.data.url) {
        const url = response.data.url;
        setTimeout(() => {
          navigate(url);
        }, 3000);
      }
    },
    [navigate],
  );

  if (props.errorType) {
    return (
      <div className="user-registration-form__error">
        <StatusInfoError message={t(`errorType.${props.errorType}`)} />
      </div>
    );
  }

  return (
    <div className="user-registration-form__form">
      <Form
        id="user-registration-form"
        action={props.userRegistrationForm.url}
        model={props.userRegistrationForm}
        method={props.userRegistrationForm.method}
        containerModifier={FormContainerModifier.WIDTH_70_CHARS}
        onSuccess={onSuccess}
      >
        <UserRegistrationFormTemplate
          emailAddress={props.emailAddress}
          loginPage={props.loginPage}
          pageTitle={props.pageTitle}
          privacyPolicyUrl={props.privacyPolicyUrl}
          registrationCompletionType={props.registrationCompletionType}
          registrationType={props.registrationType}
          roleName={props.roleName}
          termsOfServiceUrl={props.termsOfServiceUrl}
          personalDataProcessingText={props.personalDataProcessingText}
        />
      </Form>
    </div>
  );
}
